import React from "react";
import { Link } from "gatsby";
import Layout from "../../components/layout";
import SEO from "../../components/seo";
import { CardBox } from "../../components/cardbox";

const CalculatorItem = ({ children, description, to }) => (
  <div className="p-10 border border-gray-400 rounded-3xl transform hover:shadow-lg hover:-translate-y-2 transition-all duration-300 md:col-span-1">
    <Link to={to} style={{ textDecoration: "none" }}>
      <div>
        <div>
          <h3 className="text-2xl mb-5">{children}</h3>
          <hr />
        </div>
        {description && (
          <div>
            <p>{description}</p>
          </div>
        )}
      </div>
    </Link>
  </div>
);

interface CalculatorProps {
  to: string;
  description: string;
  location: string;
}

const Calculator: React.FC<CalculatorProps> = () => (
  <Layout>
    <SEO
      title="Calculators"
      description="Useful apps and calculators. Word counter, money balance prediction, money inflation."
    />
    <CardBox>
      <div className="mt-20">
        <h1 className=" text-4xl mb-10">Tools, Calculators</h1>
      </div>
      <div className="grid gap-5 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
        <CalculatorItem
          to="/calculators/money_prediction"
          description="Do you know how much money will you have in the future? Let's look on that and compute that."
        >
          Future Money
        </CalculatorItem>
        <CalculatorItem
          to="/calculators/count_words"
          description="Easy words counter. Copy paste your text, you will see how many words are there."
        >
          Words Counter
        </CalculatorItem>
        <CalculatorItem
          to="/calculators/inflation"
          description="This calculator computes how the inflation impacts the value of your money."
        >
          Money Inflation
        </CalculatorItem>
        <CalculatorItem
          to="/calculators/dynamodb-designer"
          description="Fast design of the schema and exploring access patterns"
        >
          DynamoDB Designer
        </CalculatorItem>
        <CalculatorItem
          to="/calculators/expense-tracker"
          description="Simple Budgeting App"
        >
          Simple budgeting app
        </CalculatorItem>
      </div>
    </CardBox>
  </Layout>
);

export default Calculator;
